import styled from 'styled-components';

export const ParcelTitle = styled.h1`
  font-size: 2.4rem;
  font-weight: 700;
  line-height: 3rem;
  letter-spacing: 0.05rem;
  color: ${({ theme }) => theme.colors.baseColors.grey150};
`;

export const DesktopParcelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  width: 100%;
`;

export const WrapperForParcelContainers = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2.4rem;
`;
